export default __webpack_public_path__ + "static/media/UpdateIcon.dad0c43f.svg";